import React from 'react';
import newTip from '../../imgs/menu/newtip.png';
import { isIncluded } from '../../utils';
export const getOpenList = item => {
  let openList = [];
  if (item.length > 1) openList = [item[item.length - 1]];
  else openList = item;
  return openList;
};

export const getSubClassName = (item, type, menuObj) => {
  if (!menuObj || menuObj.nightReport === undefined) return '';

  if (item.id === 18) {
    if (
      menuObj.nightReport.tip ||
      menuObj.report.tip ||
      menuObj.unPrint.tip ||
      menuObj.timeout.tip
    ) {
      return type === 'open' ? 'icon-point open' : 'icon-point';
    } else return '';
  } else if (item.id === 16) {
    if (menuObj.AIReview.tip || menuObj.tubeReview.tip) {
      return type === 'open' ? 'icon-point open' : 'icon-point';
    } else return '';
  } else return '';
};

export const getNewTipCnt = (item, menuObj) => {
  if (!menuObj || menuObj.nightReport === undefined) return '';

  if (item.pid === 18 && item.id === 19) {
    if (
      menuObj.nightReport.tip ||
      menuObj.report.tip ||
      menuObj.unPrint.tip ||
      menuObj.timeout.tip
    )
      return <img alt="" src={newTip} className="newTips" />;
    else return '';
  } else if (item.pid === 16) {
    if (
      (menuObj.AIReview.tip && item.id === 17) ||
      (menuObj.tubeReview.tip && item.id === 28)
    ) {
      return <img alt="" src={newTip} className="newTips" />;
    } else return '';
  }
};
export const playPower = (userInfo = {}) => {
  const calc1 = calcAudit([16, 28], userInfo); // 智能筛查审核：待审核
  const calc2 = calcAudit([18, 19], userInfo); // 远程诊断报告：待报告、待审核
  const calc3 = calcAudit([18, 54], userInfo);

  //登录的用户权限是否需要有提示音
  let authOpt = (userInfo.operationAuths || '').split(',');
  let hasPower = isIncluded(['T', 'M', 'Q'], authOpt);
  const auditPower = calc1 || (hasPower && (calc2 || calc3));
  return auditPower;
};
export const calcAudit = (ids, userInfo = {}) => {
  const menus = userInfo.menus || [];
  let auditFlag = false;
  if (menus.length > 0 && menus[0].childMenus.length > 0) {
    const parent = menus[0].childMenus.filter(p => p.id === ids[0])[0];
    if (parent) {
      const child = parent.childMenus.filter(c => c.id === ids[1])[0];
      if (child) auditFlag = true;
    }
  }
  return auditFlag;
};
